import { reactive, ref, computed, onMounted, watch, onBeforeMount } from '@vue/composition-api'

import * as _ from 'lodash'
import { noteChanged, formatDate, isPc, isSp } from '@/util/common'
import { searchByKeyword } from '@/util/search'

export const NoteList = (props, context) => {
  const store = context.root.$store
  const router = context.root.$router
  const route = context.root.$route
  const { note, profile } = store.state

  const currentUserId = profile.id ?? -1
  const LoadingBlock = ref(null)
  const areaScrollable = ref(null)

  onBeforeMount(async () => {

    // 閲覧モードで初期化
    store.dispatch('note/modeChange', 'detail')
    // 検索カテゴリを設定
    store.dispatch('search/setSearchCategory', 'note')
    // キーワードの同期用にストアから取り出し
    state.preKeyword = store.state.note.search.keyword

    const searchParam = await store.getters['search/getNoteSearchParam']
    
    // 検索条件を指定して遷移してきた場合
    if (Object.keys(searchParam).length > 0) {
      // store.dispatch('note/resetAllState')
      state.includeId = searchParam.id ?? null
      state.preKeyword = searchParam.search_text
        ? searchParam.search_text
        : searchParam.keyword
          ? searchParam.keyword
          : ''
      state.preKeyword && store.dispatch('note/setKeyword', state.preKeyword)
      if (state.includeId) {
        store.dispatch('note/setCurrentId', state.includeId)
        store.dispatch('note/setIncludeId', state.includeId)
      }
      if (searchParam.tags) {
        const tags = _.map(JSON.parse(searchParam.tags), id => parseInt(id))
        store.dispatch('note/setNarrowTags', tags)
      }
      if (searchParam.user_id) {
        const userIds = _.map(JSON.parse(searchParam.user_id), id => parseInt(id))
        store.dispatch('note/setNarrowUsers', userIds)
      }

      Promise
        .all([
          store.dispatch('note/reset'),
          store.dispatch('note/getOrder'),
          store.dispatch('note/getDisplay')
        ])
        .then(() => {
          action.search().then(() => {
            // タグ・ユーザーの絞り込みを再設定
            if (searchParam.tags) {
              const tags = _.map(JSON.parse(searchParam.tags), id => parseInt(id))
              store.dispatch('note/setNarrowTags', tags)
            }
            if (searchParam.user_id) {
              const userIds = _.map(JSON.parse(searchParam.user_id), id => parseInt(id))
              store.dispatch('note/setNarrowUsers', userIds)
            }
            narrow.restoreSearch()
          })
          store.dispatch('search/resetNote')
        })
    } else if (note.search.preKeyword || note.search.tags.length > 0 || note.search.user_id.length > 0) {
      state.preKeyword = note.search.keyword
      narrow.filterTags.push(...note.search.tags)
      narrow.userChecked.push(...note.search.user_id)
      const others = note.note_search_private_count > 0 && note.note_search_share_count > 0
        ? narrow.userLists[1].children : note.note_search_share_count > 0
          ? narrow.userLists[0].children : []
      
      if (_.every(others, other => note.search.user_id.includes(other.id))) {
        narrow.userChecked.push(-2)
      }
      Promise
        .all([
          store.dispatch('note/reset'),
          store.dispatch('note/getOrder'),
          store.dispatch('note/getDisplay')
        ])
        .then(() => {
          action.listLoad()
        })
    } else {
      // 画面全体のロード(検索条件が指定されていない検索)
      action.loadPage()
    }
  })

  onMounted(() => {
    if (LoadingBlock.value) {
      state.loadingHeight = LoadingBlock.value.offsetHeight + 40 + 100 + 72
    }
    state.scrollableHeight = window.innerHeight
  })

  const state = reactive({
    visible: {
      mode: computed(() => store.state.note.mode),
      deleteConfirm: false,
      copyConfirm: false,
      searchOrderSetting: false,

      visibleNoteUserPermissionsList: false,
      visibleNoteUserPermissionsEdit: computed(() => store.state.noteUserPermissionsEdit.isVisible),
      visibleMenu: false, // メニューウィンドウ表示フラグ(SP用)
      visibleMenuLeft: false, // SP用
      visibleNoteSearchMenu: false, // 検索ウィンドウ表示ボタン(虫眼鏡ボタン)表示フラグ(SP用)
      // visibleShowMenuButton: false, // メニュー表示ボタン(三本線ボタン)表示フラグ(SP用)
      visibleNoteOrderSetting: false, // SP用
      visibleNoteSearchDisplaySetting: false, // SP用
      visibleNoteSearchExtract: false, // SP用
      visibleAddTagFromPast: false, // SP用
      isFocusInput: false // SP用
    },
    isDetailMode: computed(() => store.state.note.mode === 'detail'),
    isEditMode: computed(() => store.state.note.mode === 'edit' || store.state.note.mode === 'create'),
    isFullSizeNote: false,
    isFullSize: computed(() => state.isFullSizeNote || state.isEditMode),
    currentNote: (id) => id === note.currentId,
    isOwn: computed(() => store.getters['note/isOwn']),
    isEditable: computed(() => store.getters['note/isEditable']),
    loadingHeight: 0,
    scrollableHeight: 0,
    orderDisplay: computed(() => {
      return (() => {
        switch (store.getters['note/search']) {
          case 'date_new': return '更新日（新しい順）'
          case 'date_old': return '更新日（古い順）'
          case 'name': return 'タイトル順（50音順）'
        }
      })()
    }),
    isSearch: computed(() => {
      return store.getters['note/isSearch']
    }),
    noteCount: computed(() => {
      return store.getters['note/noteCount']
    }),
    preKeyword: '',
    includeId: null,
    noteEdited: false,
    visibleNotePartPreventForgettingToSave: computed(() => store.getters['note/checkForgetToSave']),
    visibleSearchDetail: false // 詳細検索ウィンドウ表示フラグ
  })


  const narrow = reactive({
    userLists: computed(() => {
      const lists = []

      if (note.note_search_private_count > 0) {
        lists.push({ id: -1, name: 'プライベート' })
      }
      if (note.note_search_share_count > 0) {
        lists.push({ id: -2, name: '共有されたノート', children: note.userLists })
      }

      return lists
    }),
    userChecked: [],
    checkUpdate: (checked, value, allId) => {

      if (checked) {
        narrow.userChecked = _.union(narrow.userChecked, allId)
      } else {
        narrow.userChecked = _.difference(narrow.userChecked, allId)
      }

      // 編集モードで保存せずに絞り込みを実行しようとした場合、編集忘れ確認ダイアログを表示
      if (state.isEditMode && noteChanged()) {
        store.dispatch('note/setLinkTo', { type: 'mode', to: 'user_checked' })
        store.dispatch('note/showDialogToPreventForgettingToSave')
        return
      }

      narrow.loadAfterUserChecked()
    },
    /**
     * ユーザーチェック変更後の各エリアのロード処理
     */
    loadAfterUserChecked: () => {
      store.dispatch('note/setCurrentId', null) // ノート詳細を更新するためにnote/getNoteLists実行前にnullを設定
      store.dispatch('note/modeChange', 'detail')
      store.dispatch('note/reset')
      store.dispatch('note/setNarrowUsers', narrow.userChecked)
      store.dispatch('note/getNoteLists')
      store.dispatch('note/getNoteCount')
    },
    tags: computed(() => _.reject(note.tagLists, tag => _.map(narrow.filterTags, 'name').includes(tag.name))),
    filterTags: [],
    filterTagsExcludeTag: computed(() => _.filter(narrow.filterTags, tag => _.map(note.tagLists, 'name').includes(tag.name))),
    setTags: (changeTag) => {
      
      const tagsIndex = _.findIndex(narrow.tags, tag => tag.name === changeTag.name)
      narrow.tags.splice(tagsIndex, 1)
      narrow.filterTags.push(changeTag)

      // 編集モードで保存せずに絞り込みを実行しようとした場合、編集忘れ確認ダイアログを表示
      if (state.isEditMode && noteChanged()) {
        store.dispatch('note/setLinkTo', { type: 'mode', to: 'tag_changed' })
        store.dispatch('note/showDialogToPreventForgettingToSave')
        return
      }

      if (isPc()) {
        narrow.loadAfterTagChanged()
      }
    },
    resetTags: (changeTag) => {

      narrow.tags.push(changeTag)
      const tagsIndex = _.findIndex(narrow.filterTags, tag => tag.name === changeTag.name)
      narrow.filterTags.splice(tagsIndex, 1)

      // 編集モードで保存せずに絞り込みを実行しようとした場合、編集忘れ確認ダイアログを表示
      if (state.isEditMode && noteChanged()) {
        store.dispatch('note/setLinkTo', { type: 'mode', to: 'tag_changed' })
        store.dispatch('note/showDialogToPreventForgettingToSave')
        return
      }

      if (isPc()) {
        narrow.loadAfterTagChanged()
      }
    },
    /**
     * タグ変更後の各エリアのロード処理
     */
    loadAfterTagChanged: () => {
      store.dispatch('note/setCurrentId', null) // ノート詳細を更新するためにnote/getNoteLists実行前にnullを設定
      store.dispatch('note/modeChange', 'detail')
      store.dispatch('note/reset')
      store.dispatch('note/setNarrowTags', narrow.filterTags)
      store.dispatch('note/getNoteLists')
      store.dispatch('note/getNoteCount')
    },
    restoreSearch: async() => {
      const tagIds = note.search.tags
      const userIds = note.search.user_id

      if (tagIds && tagIds.length > 0) {
        const tags = _.filter(narrow.tags, tag => tagIds.includes(tag.id))
        _.each(tags, tag => narrow.setTags(tag))
      }
      
      if (userIds && userIds.length > 0) {
        narrow.userChecked.push(...userIds)
        const others = narrow.userLists.length
          ? narrow.userLists[1].children
          : []
        if (_.every(others, other => userIds.includes(other.id))) {
          narrow.userChecked.push(-2)
        }
      }
    }
  })

  const debounceGetDetail = _.debounce((now) => {
    if (now && now >= 0) {
      store.dispatch('note/getDetail')
    } else {
      store.dispatch('note/resetDetail')
    }
  }, 50)

  watch(() => note.currentId,
    (now, prev) => {
      debounceGetDetail(now)
    }
  )

  // 並び順の変更をした場合、リセットする
  watch(() => state.orderDisplay,
    (now, prev) => {
      if (prev) {
        store
          .dispatch('note/reset')
          .then(() => {
            store.dispatch('note/setCurrentId', null) // ノート詳細を更新するためにaction.load()実行前にnullを設定
            action.load()
          })
      }
    }
  )

  const action = reactive({
    setCurrentId: (id) => {
      store.dispatch('note/setCurrentId', id)
    },
    /**
     * 画面全体のロード(検索条件が指定されていない検索)
     */
    loadPage: () => {
      Promise
        .all([
          store.dispatch('note/reset'),
          store.dispatch('note/getOrder'),
          store.dispatch('note/getDisplay')
        ])
        .then(() => {
          action.search()
        })
    },
    /**
     * 「ノートの新規作成」ボタン押下時
     */
    newNote: () => {
      // 初期化
      store.dispatch('note/resetCheck')
      store.dispatch('note/modeChange', 'create')
      store.dispatch('note/setCurrentId', null)
      store.dispatch('note/resetDetail')
      store.dispatch('note/resetUserPermissions')
      store.dispatch('note/resetShareUsers')
      store.dispatch('common/addTitle', '新規作成-')

      // 共有エリアの表示判定情報(NoteEditPart.jsのstate.isShareAreaShown)を設定するため、
      // ノート利用者権限一覧を取得
      store.dispatch('note/getUserPermissions', { isShareUsersSet: false })

      if (store.state.common.device === 'sp') {
        router.push({ path: '/sp/note-edit/0' })
      }
    },
    /**
     * 「閲覧モード」タブ押下時
     */
    onViewModeTabClicked: () => {
      if (state.isDetailMode) {
        // 既に閲覧モードの場合はクリック不可
        return
      }
      action.changeMode('detail')
      // 画面全体のロード
      action.loadPage()
    },
    /**
     * 「編集モード」タブ押下時
     */
    onEditModeTabClicked: () => {
      if (state.isEditMode) {
        // 既に編集モードの場合はクリック不可
        return
      }
      store.dispatch('note/resetCheck')
      action.changeMode('edit')

      // ストア変数に保持されている内容が前の編集中の内容の場合があるため、対象ノートの詳細をロードしなおす。
      // また、更新APIに渡す編集開始日時(edit_start_time)に使用するため、現在の日時(サーバー時間)を取得しなおす
      store.dispatch('note/getDetail')
    },
    /**
     * モード変更
     */
    changeMode: (targetMode) => {
      // 編集モード表示中に閲覧モードへ切り替えようとしたとき
      if (state.isEditMode && noteChanged()) {
        store.dispatch('note/setLinkTo', { type: 'mode', to: targetMode })
        store.dispatch('note/showDialogToPreventForgettingToSave')
      } else {
        // モード切替時に片方にスクロール領域がない場合、ヘッダーが隠れたままとなってしまうので切替前に上部に戻す
        document.getElementById('note-content').scrollTop = 0
        document.getElementById('scroll-target').scrollTop = 0
        store.dispatch('note/modeChange', targetMode)
      }
      // 閲覧モード切り替え時にノートが選択されていない場合（新規作成から戻った場合）にリスト最上部を選択させる
      if (state.isDetailMode && note.currentId === null) {
        const currentId = _.get(note.noteLists, '[0].id')
        store.dispatch('note/setCurrentId', currentId)
      }
    },
    /**
     * 検索
     */
    search: async(options) => {
      // optionsの値をいったんメンバ変数に退避しておく
      action.optionForSearch = options

      // 編集モードで保存せずに検索を実行しようとした場合、編集忘れ確認ダイアログを表示
      if (state.isEditMode && noteChanged()) {
        store.dispatch('note/setLinkTo', { type: 'mode', to: 'search' })
        store.dispatch('note/showDialogToPreventForgettingToSave')
        return
      }

      // 検索(続きの処理)
      action.searchStep2()
    },
    optionForSearch: {}, // optionsの値を退避するメンバ変数
    /**
     * 検索(続きの処理)
     * ※aciton.search()メソッド、および編集忘れ確認ダイアログの選択ボタン押下時に呼ばれる
     */
    searchStep2: async() => {
      const options = action.optionForSearch
      let searchCategory
      if (
        typeof options !== 'undefined' &&
        typeof options.searchCategory !== 'undefined'
      ) {
        searchCategory = options.searchCategory
        state.preKeyword = options.search_text
      } else {
        searchCategory = group1.searchCategory
      }
  
      if (searchCategory !== 'note') {
        // 指定した検索カテゴリに対するキーワード検索を実行し、対象の検索結果画面に遷移する
        searchByKeyword(context, searchCategory, state.preKeyword, 0) 
        return
      }
  
      // 検索カテゴリを設定（onBeforeMountで設定されると思うが念のため設定）
      store.dispatch('search/setSearchCategory', 'note')

      narrow.userChecked.splice(0, narrow.userChecked.length)
      narrow.filterTags.splice(0, narrow.filterTags.length)
      
      await store
        .dispatch('note/setKeyword', state.preKeyword)
        .then(() => {
          store.dispatch('note/reset')
          store.dispatch('note/resetNarrowTags')
          store.dispatch('note/resetNarrowUsers')
          note.complete = false
          store.dispatch('note/setCurrentId', null) // ノート詳細を更新するためにaction.load()実行前にnullを設定
          action.load()
          store.dispatch('note/getUserLists')
          store.dispatch('note/getTags')
          store.dispatch('note/getNoteCount')
        })
    },
    preSearch: async() => {
      const searchParam = await store.getters['search/getNoteSearchParam']

      // 検索条件を指定してメニューから遷移してきた場合
      if (Object.keys(searchParam).length > 0) {
        state.preKeyword = searchParam.keyword
      }
      action.search()
      store.dispatch('search/resetNote')
    },
    /**
     * 詳細検索を実行する(SP画面で使用)
     * 用途：詳細検索ウィンドウの詳細検索実行ボタン押下時
     */
    searchDetail: (isResetSearchCondition) => {
      // 検索一覧画面に遷移
      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPQAList' })
      } else {
        router.push({ name: 'PCQAList' })
      }
    },    
    listLoad: () => {
      note.complete = false
      action.load()
      store.dispatch('note/getNoteCount')
    },
    /**
     * 検索をクリア
     */
    reset: () => {
      store.dispatch('note/modeChange', 'detail')

      narrow.userChecked.splice(0, narrow.userChecked.length)
      narrow.filterTags.splice(0, narrow.filterTags.length)
      // 同期用にリセットをかけた際もストアに保存
      state.preKeyword = ''
      store.dispatch('note/setKeyword', state.preKeyword)
      state.includeId = null
      store.dispatch('note/setIncludeId', state.includeId)

      // 検索UI(PCSearchUI/SPSearchUI)の検索テキストと曖昧フラグを更新する
      store.dispatch('searchUI/setSearchInputOfSearchUI', { searchText: '', isFuzzy: 0 })
      store.dispatch('searchUI/setSearchInputOfSearchUIParam', { searchCategory: group1.searchCategory, searchText: '', isFuzzy: 0 })

      action.search()
    },
    load: () => {
      store.dispatch('note/getNoteLists')
    },
    scroll: (ev) => {
      action.throttleScroll(ev)
    },
    noteEdit: (boolean) => {
      state.noteEdited = boolean
    },
    throttleScroll: _.throttle((ev) => {
      if (note.complete) return
      const { scrollTop, offsetHeight, scrollHeight } = ev.target
      // loading要素が画面内に表示されたら追加読み込み実行
      if (scrollTop + offsetHeight >= scrollHeight - state.loadingHeight) {
        action.load()
      }
    }, 300)
  })

  const group1 = reactive({
    // 検索カテゴリ（選択肢）
    searchCategory: computed({
      get: () => {
        return store.state.search.searchCategory
      },
      set: (searchCategory) => {
        store.dispatch('search/setSearchCategory', searchCategory)
      }
    })
  })

  const share = reactive({
    /**
     * 閲覧/編集権限付与アカウント一覧ウィンドウを開く
     */
    openNoteUserPermissionsList: () => {
      state.visible.visibleNoteUserPermissionsList = true
    },
    /**
     * 閲覧/編集権限付与設定ウィンドウを開く
     */
    openNoteUserPermissionsEdit: () => {
      store.dispatch('noteUserPermissionsEdit/show', 'select')
    },
    /**
     * 閲覧/編集権限付与設定ウィンドウを閉じる
     */
    hideNoteUserPermissionsEdit: () => {
      store.dispatch('noteUserPermissionsEdit/hide', 'select')
    }
  })

  const searchSelect = reactive({
    isFocusInput: false,
    currentValue: 0
  })

  const data = reactive({
    noteLists: computed(() => store.getters['note/filterNotelists']),
    detail: computed(() => store.getters['note/detail']),
    complete: computed(() => note.complete)
  })
  
  const keyword = reactive(computed(() => note.search.keyword))
  const regExp = reactive(computed(() => {
    const lower = note.search.keyword.toString().toLowerCase()
    const keywordAry = lower.split(/\s+/)
    const words = keywordAry.join('|')
    const searchWord = note.search.keyword
      ? new RegExp('(' + words + ')', 'i')
      : null

    return searchWord
  }))
  const keywordSplit = reactive(computed(() => {
    if (!note.search.keyword) {
      return []
    }
    const lower = note.search.keyword.toString().toLowerCase()
    const keywordAry = lower.split(/\s+/)

    return keywordAry
  }))

  /**
   * 編集中にヒストリーバックボタンを押したときの処理
   */
  const historyBackAction = reactive(computed(() => {
    if (state.isEditMode) {
      // 編集モードの場合
      const historyBackFunc = () => {
        // 編集モードで保存せずに履歴を戻ろうとした場合、編集忘れ確認ダイアログを表示
        if (noteChanged()) {
          store.dispatch('note/setLinkTo', { type: 'mode', to: 'history_back' })
          store.dispatch('note/showDialogToPreventForgettingToSave')
          return
        }
        // 編集していない（ノートの内容が変わっていない）場合は、なにもぜず履歴を戻る
        store.dispatch('note/forceMove') 
        router.go(-1)
      }
      return historyBackFunc
    } else {
      return null
    }
  }))

  return {
    currentUserId,
    group1,
    share,
    searchSelect,
    state,
    data,
    action,
    note,
    narrow,
    LoadingBlock,
    areaScrollable,
    formatDate,
    keyword,
    regExp,
    keywordSplit,
    historyBackAction
  }
}
